import {
   FETCH_ALLOCATED_PAYMENT_INVOICELIST_FAILURE,
   FETCH_ALLOCATED_PAYMENT_INVOICELIST_SUCCESS,
   FETCH_ALLOCATED_PAYMENT_INVOICELIST_REQUEST
  } from "./FetchAllocatedPaymentsTypes";
  
  const initialState = {
    loading: false,
    allocatedInvoiceInvoiceList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ALLOCATED_PAYMENT_INVOICELIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_ALLOCATED_PAYMENT_INVOICELIST_SUCCESS:
        return {
          loading: false,
          allocatedInvoiceInvoiceList: action.payload,
          error: "",
        };
      case FETCH_ALLOCATED_PAYMENT_INVOICELIST_FAILURE:
        return {
          loading: false,
          allocatedInvoiceInvoiceList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  